/* TrueMed 2026 home: reveal on scroll, count-up numbers, step highlights. Content is visible without this script. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('tm-io');

  function fmt(n) { return Math.round(n).toLocaleString('en-US'); }
  function count(el) {
    var to = +el.getAttribute('data-tm-count'), pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
    if (!to) { el.textContent = pre + fmt(to) + suf; return; }
    var t0 = null;
    function f(t) { t0 = t0 || t; var p = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - p, 3); el.textContent = pre + fmt(to * e) + suf; if (p < 1) requestAnimationFrame(f); }
    requestAnimationFrame(f);
  }
  function steps(el) {
    el.querySelectorAll('li').forEach(function (li, i) { setTimeout(function () { li.classList.add('tm-on'); }, 300 + i * 260); });
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; el.classList.add('tm-in'); io.unobserve(el);
      el.querySelectorAll('[data-tm-count]').forEach(count);
      if (el.hasAttribute('data-tm-count')) count(el);
      el.querySelectorAll('[data-tm-steps]').forEach(steps);
    });
  }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
  function scan(root) { (root || document).querySelectorAll('.tm-rv:not(.tm-in)').forEach(function (el) { io.observe(el); }); }
  scan();
  // pause looping animations in sections that are off screen
  var po = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('tm-off', !e.isIntersecting); }); }, { rootMargin: '200px 0px' });
  document.querySelectorAll('.tm-s, .tm-pmq').forEach(function (el) { el.classList.add('tm-off'); po.observe(el); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); e.target.querySelectorAll('.tm-rv').forEach(function (el) { el.classList.add('tm-in'); }); });
})();
